// extracted by mini-css-extract-plugin
export var articleDetail = "h_bp";
export var title = "h_bq";